require('./lbaPerDiemFileUploader.scss');
const $inject = [];
const lbaPerDiemFileUploader = function () {
  return {
    restrict: 'A',
    scope: {
      settings: '<',
    },
    bindToController: true,
    controller: 'lbaPerDiemFileUploaderCtrl',
    controllerAs: 'vm',
    template: require('./lbaPerDiemFileUploader.html')
  }
};

lbaPerDiemFileUploader.$inject = $inject;

export default lbaPerDiemFileUploader;


// WEBPACK FOOTER //
// ./src/components/lbaPerDiemFileUploader/lbaPerDiemFileUploaderDir.js